import { Icon } from './Icon'
import type { CloudVendor } from '../lib/providers'
import { vendorForKind } from '../lib/providers'

const marks: Record<CloudVendor, string> = {
  aws: 'aws', azure: 'az', google: 'G', cloudflare: 'CF', oracle: 'O', alibaba: 'Ali', local: '', other: 'API',
}

export function CloudMark({ vendor, kind, size = 'md', className = '' }: { vendor?: CloudVendor; kind?: string; size?: 'sm' | 'md' | 'lg'; className?: string }) {
  const resolved = vendor || vendorForKind(kind || '')
  return <span className={`cloud-mark cloud-mark-${resolved} cloud-mark-${size} ${className}`.trim()} aria-label={vendorLabel(resolved)}>
    {resolved === 'local' ? <Icon name="server" size={size === 'lg' ? 25 : size === 'sm' ? 15 : 19} /> : <b>{marks[resolved]}</b>}
  </span>
}

export function vendorLabel(vendor: CloudVendor): string {
  const labels: Record<CloudVendor, string> = { aws: 'AWS', azure: 'Microsoft Azure', google: 'Google Cloud', cloudflare: 'Cloudflare', oracle: 'Oracle Cloud', alibaba: 'Alibaba Cloud International', local: '本地服务器', other: '自定义 API' }
  return labels[vendor]
}
